var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 61.3 63.1",
    style: {
      enableBackground: "new 0 0 61.3 63.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9B0008;}\n\t.st1{fill:#2D2D2D;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.8,0.4L14.5,22.8c2.3,2,5.3,3.2,8.4,3.1c5.2,0,13.4-10.7,13.4-10.7l21.6,18.2c0,0,3.5-9.8,2.9-17.2 c-0.6-7.4-1-8.4-1-8.4S49.1,1.2,33.8,0.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.3,47.1c-1.3-1.4,0.6-2.7,1.8-1.6c1,1.1,12.3,10.7,14.3,12.5c2.1-1.5,4.1-3.1,5.9-4.8 c-1.9-1.6-15.4-13.1-16.2-14c-0.8-1,0.6-2.4,1.6-1.6c1,0.8,16,13.7,16.2,13.9c1.6-1.7,3.1-3.5,4.5-5.4V46c0,0-15.2-13-16.2-14 c-1-1,1-2.4,1.6-1.8c0.5,0.6,16,13.7,16,13.7h0.1c1.6-2.6,3.1-5.2,4.3-7.9c-4.9-3.9-20.7-17.5-20.7-17.5s-6.2,9.6-13.8,9.9 c-5.7,0.2-11.3-4.7-11.3-4.7L30.7,0.4c0,0-16.8-0.4-29.1,7.1c0,0-1.3-1.2-1.2,10.8s6,34.2,30.2,44.4c2.4-1,4.8-2.2,7.1-3.6 C36.1,57.8,24.6,48.4,23.3,47.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a574a5bf78248f923754b7250351713b.svg";
export { ForwardRef as ReactComponent };